(() => {
  if (customElements.get('eb-collection-tabs')) return;

  customElements.define(
    'eb-collection-tabs',
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-eb-tab-target]')];
        this.panels = [...this.querySelectorAll('[data-eb-tab-panel]')];
        this.onEditorBlockSelect = (event) => this.handleEditorBlockSelect(event);

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab.dataset.ebTabTarget));
        });

        document.addEventListener('shopify:block:select', this.onEditorBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onEditorBlockSelect);
      }

      handleEditorBlockSelect(event) {
        const panel = event.target?.closest?.('[data-eb-tab-panel]');
        if (!panel || !this.contains(panel)) return;
        this.select(panel.dataset.ebTabPanel);
      }

      select(id) {
        if (!id) return;

        this.tabs.forEach((tab) => {
          const active = tab.dataset.ebTabTarget === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const active = panel.dataset.ebTabPanel === id;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;

          if (active) {
            panel.querySelectorAll('[data-eb-carousel-track]').forEach((track) => {
              track.scrollTo({ left: 0 });
            });
            panel.querySelectorAll('eb-carousel').forEach((carousel) => carousel.update?.());
          }
        });
      }
    }
  );
})();
